import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// La bouteille agrandie : image PNG détourée avec halo noir INTÉGRÉ dans l'image.
// Aucun filtre CSS, aucun cadre : rendu strictement identique sur iPad, iPhone et ordinateur.
export default function ImageZoom({ src, alt, onClose, viaHover = false, onStick }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div
          className="fixed inset-0 z-[70] flex items-center justify-center cursor-zoom-out"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          onMouseMove={viaHover ? onClose : undefined}
          data-testid="image-zoom-overlay"
        >
          <button
            onClick={onClose}
            className="absolute right-5 p-2.5 rounded-full bg-[#6B1226] text-[#FAF6F0] shadow-lg hover:bg-[#580E1D] transition-colors z-10"
            style={{ top: "calc(1.25rem + env(safe-area-inset-top, 0px))" }}
            data-testid="image-zoom-close"
            aria-label="Fermer"
          >
            <X size={22} />
          </button>
          <motion.img
            src={src}
            alt={alt || ""}
            initial={{ scale: 0.6, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.85, opacity: 0, y: 20 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => {
              e.stopPropagation();
              onStick?.();
            }}
            className="relative max-h-[88vh] max-w-[92vw] w-auto object-contain no-frame"
            data-testid="image-zoom-img"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
